<template>
    <v-container class="pb-0 pt-10">
        <v-layout row wrap>
            <v-flex xs12 sm4 v-if="$vuetify.breakpoint.smAndUp">
                <img :src="require('../assets/DEOK_karta_image-new-min.png')" style="max-width: 100%" />
            </v-flex>
            <v-flex xs12 sm8>
                <request-form />
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import RequestForm from './Form'

    export default {
        name: 'CardForm',
        components: {
            RequestForm
        }
    }
</script>